require('./openYoungDashboardView.scss');

// @ vendors
const { connect } = require('react-redux');
const classNames = require('classnames');
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const WizardError = require('components/commons/wizardError/wizardError');

// @ actions
const { getChildDetails } = require('actions/openYoungDashboardChildDetails');
const { getChildList } = require('actions/openYoungDashboard');

// @ components
const Avatar = require('components/avatar/avatar');
const OpenYoungDashboardBudgetContent = require('components/openYoungDashboard/openYoungDashboardBudgetContent/openYoungDashboardBudgetContent')
const OpenYoungDashboardChildContent = require('components/openYoungDashboard/openYoungDashboardChildContent/openYoungDashboardChildContent');
const OpenYoungDashboardChoresContent = require('components/openYoungDashboard/openYoungDashboardChoresContent/openYoungDashboardChoresContent')
const OpenYoungDashboardExpensesContent = require('components/openYoungDashboard/openYoungDashboardExpensesContent/openYoungDashboardExpensesContent')

// @helpers
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname');
const { formatText, FormattedText } = require('core/i18n').i18n;
const { getFirstNChars, getFirstNWords } = require('utilities/stringHelper');

class OpenYoungDashboardView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedChild: 0
        };
        this.getAvatarSection = this.getAvatarSection.bind(this);
        this.onChildAvatarClick = this.onChildAvatarClick.bind(this);
    }

    componentDidMount() {
        const { getChildList } = this.props;
        getChildList();
    }

    getAvatarSection(immChildList) {
        const { selectedChild } = this.state;
        const avatarSection = immChildList.map((child, index) => {
            const childNameFirstWord = getFirstNWords(child.get('childName'), 1, '', 0);
            const childName = getFirstNChars(childNameFirstWord, 5);
            const imgType = index === selectedChild ? 'highlight-mode' : 'disabled-mode';
            const imgUrl = child.get('image');
            const arrowClass = classNames('open-young-dashboard-view__arrow-top ', {
                'open-young-dashboard-view__arrow-top--disabled-mode': imgType === 'disabled-mode',
            });
            return (
                <div className="open-young-dashboard-view__avatar-view-content"
                    id="oy-avatar-content"
                    key={`childAvatar_${index}`}
                    onClick={() => this.onChildAvatarClick(index)}
                >
                    <Avatar
                        id={`childAvatar_${index}`}
                        imgDescription={child.get('childName').trim()}
                        imgType={imgType}
                        imgUrl={imgUrl}
                    />
                    <span className="open-young-dashboard-view__avatar-view-child-name">{childName}</span>
                    <div className={arrowClass}></div>
                </div>
            );
        });
        return (
            <div className="open-young-dashboard-view__avatar-view">
                {avatarSection}
            </div>
        );
    }

    onChildAvatarClick(index) {
        const {
            getChildDetails,
            immOpenYoungDashboard
        } = this.props;
        const immChildList = immOpenYoungDashboard.get('openYoungChildList');
        const immChild = immChildList.find((child, i) => i === index);
        let cardDetails;
        if (!!immChild.get('card')) {
            cardDetails = {
                contractNumber: immChild.getIn(['card', 'contractNumber']),
                pan: immChild.getIn(['card', 'pan']),
                productCode: immChild.getIn(['card', 'productCode'])
            };
            getChildDetails(cardDetails);
        }
        this.setState({ selectedChild: index });
    }

    handleOnClick() {
        this.props.history.push('/myprofile/open-young-dashboard/history');
    }

    render() {
        const {
            immAccounts,
            immCards,
            immOpenYoungDashboard,
            immOpenYoungDashboardChildDetails,
            getChildDetails
        } = this.props;
        const { selectedChild } = this.state;
        let accountCardInfo;
        let childAvatarContent;
        let childDetails;
        let childName = '';
        let historyButton;
        if (immOpenYoungDashboard.get('isFetchingChildList')) {
            accountCardInfo = <LoadingSection />;
        } else if (immOpenYoungDashboard.get('childListError')) {
            const errorMessage = <FormattedText value="confirmationSolidarityCard-genericError" />;
            accountCardInfo = (
                <WizardError errorMessage={errorMessage}>
                    <FormattedText value="confirmationSolidarityCard-genericErrorText" />
                </WizardError>
            );
        } else if (immOpenYoungDashboard.get('childListSuccess')) {
            const immChildList = immOpenYoungDashboard.get('openYoungChildList');
            childAvatarContent = this.getAvatarSection(immChildList);

            const immChild = immChildList.find((child, index) => index === selectedChild);
            const immCardsById = immCards.get('byId');
            const immCardsByOrder = immCards.get('byOrder');
            const childCardContractNumber = !!immChild.get('card') ? immChild.getIn(['card', 'contractNumber']) : '';
            let selectedCardId;
            childName = ' > ' + immChild.get('childName');

            if (!!childCardContractNumber) {
                selectedCardId = immCardsByOrder.find(cardId => immCardsById.getIn([cardId, 'contract', 'number']) === childCardContractNumber);
            }
            accountCardInfo = (
                <OpenYoungDashboardChildContent
                    immAccountDetails={immChild.get('account')}
                    immAccounts={immAccounts}
                    immCardDetails={immChild.get('card')}
                    immCards={immCards}
                />
            );
            if (!!immChild.get('card')) {
                childDetails = (
                    <React.Fragment>
                        <div className="open-young-dashboard-view__content">
                            <OpenYoungDashboardChoresContent
                                immOpenYoungDashboardChildDetails={immOpenYoungDashboardChildDetails}
                                cardInfo={immChild.get('card')}
                                cardId={selectedCardId}
                                getChildDetails={getChildDetails}
                            />
                        </div>
                        <div className="open-young-dashboard-view__content">
                            <OpenYoungDashboardExpensesContent
                                immOpenYoungDashboardChildDetails={immOpenYoungDashboardChildDetails}
                                cardInfo={immChild.get('card')}
                                cardId={selectedCardId}
                            />
                        </div>
                        <div className="open-young-dashboard-view__content">
                            <OpenYoungDashboardBudgetContent
                                immOpenYoungDashboardChildDetails={immOpenYoungDashboardChildDetails}
                                cardInfo={immChild.get('card')}
                                cardId={selectedCardId}
                                getChildDetails={getChildDetails}
                            />
                        </div>
                    </React.Fragment>
                );

                historyButton = (
                    <OKButton modifier="primary" inverse={true} onClick={() => this.handleOnClick()}>
                        <FormattedText value="openYoungDashboardView-openYoungDashboardView_historyButton" />
                    </OKButton>
                );
            }
        }

        const mappingBreadcrumb = [
            {
                text: formatText('openYoungDashboardView-openYoungDashboardView_breadcrumbEntry') + childName
            },
        ];

        const gridViewBodyClassname = contactCenterClassName('open-young-dashboard-view_body', 'grid-view__body');
        return (
            <div className="open-young-dashboard-view">
                <div className="container-fluid open-young-dashboard--header-identifier">
                    <div className="row">
                        <OKCover size="large" section="broker" customClass="col-xs-12">
                            <OKHeaderSubPage breadcrumbConfig={mappingBreadcrumb}>
                                {historyButton}
                            </OKHeaderSubPage>
                        </OKCover>
                        <div className="open-young-dashboard-view__cover-content ok-cover__content">
                            {childAvatarContent}
                        </div>
                    </div>
                </div>
                <div className={gridViewBodyClassname}>
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-md-12">
                                <div className="open-young-dashboard-view__content">
                                    {accountCardInfo}
                                </div>
                                {childDetails}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

OpenYoungDashboardView.propTypes = {
    getChildDetails: PropTypes.func.isRequired,
    getChildList: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immOpenYoungDashboard: PropTypes.object.isRequired,
    immOpenYoungDashboardChildDetails: PropTypes.object.isRequired,
};

module.exports.constructor = OpenYoungDashboardView;
module.exports.OpenYoungDashboardView = connect(
    state => ({
        immAccounts: state.accounts,
        immCards: state.cards,
        immOpenYoungDashboard: state.openYoungDashboard,
        immOpenYoungDashboardChildDetails: state.openYoungDashboardChildDetails,
    }),
    {
        getChildDetails,
        getChildList,
    }
)(withRouter(OpenYoungDashboardView));
